<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Fleet Information</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="fleetCreationForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Requested Expiration</label>
                    <select class="mvd_form-control" formControlName="expirationDate">
                        <option *ngFor="let generatedEndDate of generatedEndDates" value="{{generatedEndDate}}">{{generatedEndDate}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="fleetCreationForm.controls['expirationDate'].touched && fleetCreationForm.controls['expirationDate'].hasError('required')">Expiration date is required</div>
                    </div>
                </div>
                <div class="col-sm-5 mvd_form-group">
                    <label class="required" title="* Required">Fleet Type</label>
                    <select class="mvd_form-control" formControlName="fleetType">
                        <option *ngFor="let fleetType of fleetTypes" value="{{fleetType.id}}">{{fleetType.displayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="fleetCreationForm.controls['fleetType'].touched && fleetCreationForm.controls['fleetType'].hasError('required')">Fleet type is required</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Customer Account</label>
                    <select class="mvd_form-control" formControlName="customerAccountNumber">
                        <option *ngFor="let customerAccountNumber of customerAccountNumbers" value="{{customerAccountNumber.customerAccountNumberId}}">{{customerAccountNumber.accountName}} ({{customerAccountNumber.customerAccountNumberId}})</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="fleetCreationForm.controls['customerAccountNumber'].touched && fleetCreationForm.controls['customerAccountNumber'].hasError('required')">Customer account number is required</div>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!fleetCreationForm.valid" [isLoading]="showButtonLoading" [btnText]="'Submit'" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>